import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MmButtonModule, MmFlexLayoutModule, MmIconModule } from '@metromarkets/components';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { MmExpansionModule } from '~shared/modules/mm-expansion/mm-expansion.module';

import { BuyboxSellerComponent } from '~app/modules/seller/components/buybox-seller/buybox-seller.component';
import { SellerLegalInfoComponent } from '~app/modules/seller/components/seller-legal-info/seller-legal-info.component';
import { PageLoadingModule } from '~shared/components/page-loading/page-loading.module';
import { BasePageModule } from '~shared/modules/base-page/base-page.module';
import { SanitizeModule } from '~shared/pipes/sanitaze/sanitaze.module';
import { MailModule } from '~shared/svgs/mail/mail.module';
import { MediumShop } from '~shared/svgs/medium-shop/medium-shop.module';
import { SellerAvatarModule } from '../seller-avatar/seller-avatar.module';
import { SellerComponent } from './components/seller.component';
import { TabComponent } from './components/tabs/tab/tab.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { LinkifyPipe } from './pipes/linkify.pipe';
import { SellerRoutingModule } from './seller-routing.module';
import { reducers, SELLER_FEATURE_NAME } from './store';
import { SellerEffects } from './store/seller';

@NgModule({
  declarations: [
    SellerComponent,
    SellerLegalInfoComponent,
    TabsComponent,
    TabComponent,
    BuyboxSellerComponent,
    LinkifyPipe,
  ],
  imports: [
    CommonModule,
    SellerRoutingModule,
    SellerAvatarModule,
    TranslateModule,
    MmButtonModule,
    MmFlexLayoutModule,
    MmIconModule,
    MmExpansionModule,
    BasePageModule,
    PageLoadingModule,
    StoreModule.forFeature(SELLER_FEATURE_NAME, reducers),
    EffectsModule.forFeature([SellerEffects]),
    MediumShop,
    MailModule,
    SanitizeModule,
  ],
  exports: [SellerLegalInfoComponent, BuyboxSellerComponent],
})
export class SellerModule {}
